import { ValidationError } from './validation.js';
import { Func, Var, ConstVar } from '../../../WebPd_compiler/dist/src/ast/declare.js';
import '../../../WebPd_compiler/dist/src/compile/proxies.js';
import '../../../WebPd_compiler/dist/src/compile/precompile/proxies.js';

const TYPE_ARGUMENTS = [
    'float',
    'bang',
    'symbol',
    'list',
    'anything',
];
const resolveTypeArgumentAlias = (value) => {
    switch (value) {
        case 'f':
            return 'float';
        case 'b':
            return 'bang';
        case 's':
            return 'symbol';
        case 'l':
            return 'list';
        case 'a':
            return 'anything';
        case 'p':
            return 'pointer';
        default:
            return value;
    }
};
const assertTypeArgument = (value) => {
    if (value === 'pointer') {
        throw new ValidationError(`"pointer" not supported (yet)`);
    }
    else if (!TYPE_ARGUMENTS.includes(value)) {
        throw new ValidationError(`invalid type ${value}`);
    }
    return value;
};
const renderMessageTransfer = (typeArgument, msgVariableName, index, { msg, bangUtils, tokenConversion }) => {
    switch (typeArgument) {
        case 'float':
            return `${msg.floats}([${tokenConversion.toFloat}(${msgVariableName}, ${index})])`;
        case 'bang':
            return `${bangUtils.bang}()`;
        case 'symbol':
            return `${msg.strings}([${tokenConversion.toString_}(${msgVariableName}, ${index})])`;
        case 'list':
        case 'anything':
            return `${msgVariableName}`;
        default:
            throw new Error(`type argument ${typeArgument} not supported (yet)`);
    }
};
const NAMESPACE = 'tokenConversion';
const messageTokenToFloat = {
    namespace: NAMESPACE,
    // prettier-ignore
    code: ({ ns: tokenConversion }, { msg }) => Func(tokenConversion.toFloat, [
        Var(msg.Message, `m`),
        Var(`Int`, `i`)
    ], 'Float') `
        if (${msg.isFloatToken}(m, i)) {
            return ${msg.readFloatToken}(m, i)
        } else {
            return 0
        }
    `
};
const messageTokenToString = {
    namespace: NAMESPACE,
    // prettier-ignore
    code: ({ ns: tokenConversion }, { msg }) => Func(tokenConversion.toString_, [
        Var(msg.Message, `m`),
        Var(`Int`, `i`)
    ], 'string') `
        if (${msg.isStringToken}(m, i)) {
            ${ConstVar(`string`, `str`, `${msg.readStringToken}(m, i)`)}
            if (str === 'bang') {
                return 'symbol'
            } else {
                return str
            }
        } else {
            return 'float'
        }
    `
};

export { assertTypeArgument, messageTokenToFloat, messageTokenToString, renderMessageTransfer, resolveTypeArgumentAlias };
